import * as React from 'react';
import { connect } from 'react-redux';

import { fetchConfig, resetConfig } from 'redux-store/reducers/runtime-config';

type OwnProps = {};

type StateProps = {
  hiddenSectionsByCssSelectorsString: string | undefined | null
};

type DispatchProps = {
  dispatchFetchConfig: () => void,
  dispatchResetConfig: () => void
};

type Props = OwnProps & StateProps & DispatchProps;

class RuntimeConfigProvider extends React.PureComponent<Props> {
  componentDidMount() {
    const { dispatchFetchConfig } = this.props;

    dispatchFetchConfig();
  }

  componentWillUnmount() {
    const { dispatchResetConfig } = this.props;

    dispatchResetConfig();
  }

  render(): React.ReactNode {
    const { hiddenSectionsByCssSelectorsString } = this.props;

    return hiddenSectionsByCssSelectorsString ?
      <style>
        {hiddenSectionsByCssSelectorsString} {'{ display: none; }'}
      </style> :
      null;
  }
}

const mapStateToProps = ({ runtimeConfig }): StateProps => ({
  hiddenSectionsByCssSelectorsString: (runtimeConfig.config.hiddenSectionsByCssSelectors || []).join(',')
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchConfig: () => dispatch(fetchConfig()),
  dispatchResetConfig: () => resetConfig()
});

export default connect(mapStateToProps, mapDispatchToProps)(RuntimeConfigProvider);
